import { __assign } from "tslib";
// DS: I125
// from GDrive
import React from 'react';
import IconWrap from '../../IconWrap';
var CommentOutline = function (props) {
    return (React.createElement(IconWrap, __assign({}, props),
        React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
            React.createElement("path", { fillRule: "evenodd", d: "M20 3a1 1 0 01.993.883L21 4v9.586a1 1 0 01-.206.608l-.087.099-2.414 2.414a1 1 0 01-.576.284l-.131.009H13l-2.7 3.6a1 1 0 01-.683.393L9.5 21H8a1 1 0 01-.993-.883L7 20v-3H4a1 1 0 01-.993-.883L3 16V6.414a1 1 0 01.206-.608l.087-.099 2.414-2.414a1 1 0 01.576-.284L6.414 3H20zm-1 2H6.828L5 6.828V15h4v4l3-4h5.17L19 13.17V5z" }))));
};
CommentOutline.displayName = 'CommentOutline';
export default CommentOutline;
//# sourceMappingURL=CommentOutline.js.map